import { AgGridReact } from "@jsq/ds/core";
import { formatDateWithDefaultUtc } from "../../../../utils/date_formatter";

export type FilterEntity = {
  id: string;
  name: string;
};

type EntityColumnDefsOptions = {
  filterEntities: FilterEntity[];
  showPendingDivestment: boolean;
};

export const getEntityColumnDefs = ({
  filterEntities,
  showPendingDivestment,
}: EntityColumnDefsOptions): AgGridReact.AgGridReactProps["columnDefs"] => {
  const entityIds = filterEntities.map((e) => e.id);
  const entityNameMap = new Map(filterEntities.map((e) => [e.id, e.name]));

  return [
    {
      field: "entityName",
      headerName: "Entity",
      flex: 1,
      minWidth: 250,
      pinned: true,
      sortable: true,
      filter: "agSetColumnFilter",
      filterParams: {
        values: entityIds,
        valueFormatter: ({ value }: { value: string }) => entityNameMap.get(value) ?? value,
        caseSensitive: false,
      },
      menuTabs: ["filterMenuTab", "generalMenuTab", "columnsMenuTab"],
    },
    {
      field: "totalPositions",
      headerName: "Total positions",
      flex: 1,
      minWidth: 110,
      sortable: false,
    },
    {
      field: "compliant",
      headerName: "Compliant",
      flex: 1,
      minWidth: 110,
      sortable: false,
    },
    {
      field: "reviewNotStarted",
      headerName: "Review not started",
      flex: 1,
      minWidth: 115,
      sortable: false,
    },
    {
      field: "inJSQReview",
      headerName: "Juniper Square review",
      flex: 1,
      minWidth: 150,
      sortable: false,
    },
    {
      field: "inLPSubmission",
      headerName: "LP submission",
      flex: 1,
      minWidth: 110,
      sortable: false,
    },
    {
      field: "pendingDivestment",
      headerName: "Pending divestment",
      flex: 1,
      minWidth: 140,
      sortable: false,
      hide: !showPendingDivestment,
    },
    {
      field: "lastActivity",
      headerName: "Last activity",
      flex: 1,
      minWidth: 125,
      sortable: false,
      valueFormatter: ({ value }) => formatDateWithDefaultUtc(value),
    },
  ];
};
